import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject } from 'rxjs';

export interface Event {
  id: number;
  title: string;
  description: string;
  time: Date;
  image: string;
  cta_link: string;
  cta_text: string;
  patron_only: number; // The tier needed to access the event. -1 = Everyone
}

@Injectable({
  providedIn: 'root'
})
export class EventService {

  api: ApiService = inject(ApiService);

  constructor() { }

  public $events: BehaviorSubject<Event[]> = new BehaviorSubject<Event[]>([]);

  getEvents() {
    this.api.get("events/getEvents.php").subscribe((data: any) => {
      data.events.forEach((event: Event) => {
        event.time = new Date(event.time as any * 1000);
      });
      this.$events.next(data.events);
    });
  }

  getEventById(id: number): Event | undefined {
    return this.$events.value.find((event: Event) => event.id === id);
  }

  getUpcomingEvents(): Event[] {
    const now = new Date();
    return this.$events.value.filter((event: Event) => event.time > now);
  }
}
